var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Attach_18px",
    transform: "translate(-503 -5350)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 18,
    height: 18,
    transform: "translate(503 5350)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "attach-outline",
    d: "M163,84.462v6.515a1.815,1.815,0,1,0,3.63,0l.006-8.54a3.077,3.077,0,1,0-6.154,0v8.6a4.326,4.326,0,1,0,8.651,0V83",
    transform: "translate(347.189 5271.64)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFileIcon);
export default __webpack_public_path__ + "static/media/attach-file-icon.4b275694924ee30795ee6fb194734587.svg";
export { ForwardRef as ReactComponent };